/*
 * Jira Ticket:
 * Created Date: Mon, 4th Nov 2019, 11:41:26 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */

export const NEXT_CURSOR = 'TD/NEXT_CURSOR';

export const nextCursor = (cursor, page) => ({
  payload: {
    cursor,
    page,
  },
  type: NEXT_CURSOR,
});
